export enum QuanLyHaTangKyThuatActiontype {
  ChangeTabindexActiontype = 'ChangeTabindexActiontype',
  getList = 'getList',
  GetListHDXD = 'GetListHDXD',
  GetDataCount = 'GetDataCount'
}